import { Calendar } from '../interfaces/calendar';
import { Championship } from '../interfaces/championship';
import { GameTeam } from 'modules/games/domain/interfaces/game';
import { MatchDto } from '../interfaces/dtos';
import { SportType } from 'modules/core/domain/enums/sport-type';
import { mapChampionshipSettings } from 'modules/tournaments/domain/data-mappers/championship-game-teams-mapper';

export function matchesMapper(matches: MatchDto[]): Calendar {
  const calendar: Calendar = {};

  for (const match of matches) {
    if (!match || !match.teams || !match.teams?.length || !match.date) {
      continue;
    }

    const date = new Date(match.date);
    const championship = match.championship;

    const mappedChampionship: Championship = {
      id: championship.id,
      name: championship.name,
      tournamentId: championship.tournament.id,
      address: championship.tournament.address,
      settings: mapChampionshipSettings(championship.settings),
    };

    const teams = match.teams?.map((team) => {
      const score = match.teamMatches?.find((tm) => tm.team?.id === team.id)?.score ?? undefined;
      return {
        id: team.id,
        players: [],
        score,
        name: team.name,
        shortName: team.shortName,
        logo: team.emblem
          ? {
              url: team.emblem.externalUrl,
            }
          : undefined,
      };
    });

    const matchMapped = {
      id: match.id,
      date: match.date,
      teams: [teams[0], teams[1]] as [GameTeam | null, GameTeam | null],
      hasResults: false,
      sportType: match.sportType as SportType,
      address: championship?.tournament?.address?.city ?? undefined,
    };

    const month = date.toLocaleString('ru-RU', { month: 'long' });
    calendar[month] = calendar[month] || [];
    let day = calendar[month].find((d) => new Date(d.date).getDate() === date.getDate());
    if (!day) {
      day = { date: date.toISOString(), matches: [] };
      calendar[month].push(day);
    }

    day.matches.push({
      ...matchMapped,
      championship: mappedChampionship,
    });
  }

  return calendar;
}
